import { useTranslation } from 'next-i18next'

import SVGImage from '~/components/Image/SVGImage'
import { MathEssentialActivityStat } from '~/redux/apis/user-stats-api'

export default function ArticleStat({ activity }: { activity: MathEssentialActivityStat }): React.ReactElement {
  const { t } = useTranslation('statistics')

  const { title, isCompleted } = activity

  return (
    <div className="flex justify-start pt-3">
      <div className="flex items-center space-x-4">
        <div className="flex space-x-2">
          <SVGImage alt={t('alt_texts.article')} srcKey="scoreboard/math-essential-article.svg" />
        </div>
        <p>{title}</p>
      </div>
      {isCompleted && (
        <div className="flex items-center ml-5">
          <SVGImage alt={t('alt_texts.tick')} srcKey="scoreboard/tick-with-border.svg" />
        </div>
      )}
    </div>
  )
}
